import { Instance, types } from "mobx-state-tree";

export const Account = types.model({
  id: types.identifier,
  slug: types.string,
  type: types.maybeNull(types.string),
  role: types.string,
  displayName: types.maybeNull(types.string),
  avatarUrl: types.maybeNull(types.string),
});

export type AccountType = Instance<typeof Account>;
export type PersonalAccountType = Instance<typeof Account>;

export const GlobalStore = types
  .model({
    personalAccount: types.maybe(Account),
    organizations: types.map(Account),
  })
  .views((self) => ({
    accountBySlug(slug: string) {
      if (self.personalAccount?.slug === slug) {
        return self.personalAccount;
      }

      return Array.from(self.organizations.values()).find(
        (org) => org.slug === slug,
      );
    },
    accountById(id: string) {
      if (self.personalAccount?.id === id) {
        return self.personalAccount;
      }

      return self.organizations.get(id);
    },
  }));

export type GlobalStoreType = Instance<typeof GlobalStore>;
